import createFormReducer from "./actions-reducers/form/create-form-reducer"
import {
    FORM_CARD_INFO_NAME,
    formCardInfoReducer
} from "../_pages/Sale/_partials/PaymentStep/_components/FormCardInfo/reducer"
import {FORM_REGISTRATION, formRegistrationReducer} from "./actions-reducers/form-registration/reducer";
import {
    FORM_TUTORIA_NAME,
    formTutoriaReducer
} from "../_pages/Account/_pages/CourseList/_pages/Course/_partials/Tutoria/form-reducer";


export default {


    [FORM_TUTORIA_NAME] : formTutoriaReducer,
    [FORM_CARD_INFO_NAME]: formCardInfoReducer,
    [FORM_REGISTRATION]: formRegistrationReducer,

    formTest: createFormReducer('formTest', ({
                                                 username = '',
                                                 password = ''
                                             }) => {
        let errorMessages = {}

        if (username.length < 3)
            errorMessages['username'] = ['Nome do usuário deve possuir mais do que 3 chars.']

        if (password.toUpperCase() === 'NERIT')
            errorMessages['password'] = ['Por favor, troque sua senha padrao.']

        return errorMessages
    })
}






// WEBPACK FOOTER //
// ./src/redux/reducers.js